import { combineReducers } from 'redux';
import { runtimeReducer } from './runtime';
import { salonReducer } from './salon';
import { bookingReducer } from './booking';
import { bookingSettingsReducer } from './bookingSettings';

const rootReducer = combineReducers({
  runtime: runtimeReducer,
  salonStore: salonReducer,
  bookingStore: bookingReducer,
  bookingSettings: bookingSettingsReducer,
});

export default rootReducer;
